import { Textual }			from "@v3/data/textual";
import { NonEmptyString }	from "@v3/data/primitive/nonEmptyString";

export type EmailAddress	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"EmailAddress",
		/^[a-zA-Z0-9.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
		"must be a simple email address without name or comments"
	);

namespace Extension {
	// this is legal, email addresses are never empty
	export const toNonEmptyString	= NonEmptyString.brand;
}

export const EmailAddress	= { ...Extension, ...Base };
